var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":require("@assets/img/404-icon.svg"),"alt":"404 Image"}}),_c('h1',[_vm._v("Invalid Information")]),_c('p',[_vm._v("We couldn't find the page you're looking for.")])])
}]

export { render, staticRenderFns }